import React, { useState } from "react";
import Chartcontext from "./Chartcontext";
const ChartContextProvider = ({ children }) => {
  const [get, setget] = useState([]);
  const [audit, setaudit] = useState([]);
  const [inpval, setInputval] = useState({
    admit_date: "",
    chart_no: "",
    coder_comments: "",
    date_of_completion: "",
    discharge_date: "",
    em: "",
    mr_no: "",
    primary_diagnosis: null,
  });
  const [chartstatus, setchartstatus] = useState([]);
  const [responsible, setresponsible] = useState([]);
  const [holdreason, setholdreason] = useState([]);
  const [auditor, setauditor] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [disposition, setDisposition] = useState([]);
  const [flagChange, setFlagChange] = useState(true);
  const [defaultAudit, setDefaultAudit] = useState();
  const [defaultHold, setDefaultHold] = useState();
  const [isQc, setIsQc] = useState(null);
  const [defaultQC, setDefaultQC] = useState({});
  const [defaultResponsible, setDefaultResponsible] = useState();
  const [defaultChartStatus, setDefaultChartStatus] = useState();
  const [defaultDisposition, setDefaultDisposition] = useState();
  const [defaultSubSpecialty, setDefaultSubSpecialty] = useState();
  const [defaultPrimaryHealth, setDefaultPrimaryHealth] = useState();
  const [defaultFacility, setDefaultFacility] = useState();
  const [allocateAuditor, setAllocateAuditor] = useState();
  const [allocateEDCoder, setAllocateEDCoder] = useState(null);
  const [priority, setPriority] = useState(null);
  const [activityLogs, setActivityLogs] = useState({});
  return (
    <Chartcontext.Provider
      value={{
        flagChange,
        activityLogs,
        get,
        audit,
        chartstatus,
        responsible,
        holdreason,
        auditor,
        masterData,
        inpval,
        setFlagChange,
        setActivityLogs,
        setget,
        setaudit,
        setchartstatus,
        setresponsible,
        setholdreason,
        setauditor,
        setMasterData,
        setInputval,
        disposition,
        defaultSubSpecialty,
        defaultAudit,
        defaultHold,
        defaultPrimaryHealth,
        defaultFacility,
        defaultResponsible,
        defaultChartStatus,
        defaultDisposition,
        setDefaultDisposition,
        allocateAuditor,
        allocateEDCoder,
        setDisposition,
        setDefaultAudit,
        setDefaultHold,
        setDefaultResponsible,
        setDefaultChartStatus,
        setDefaultSubSpecialty,
        setAllocateAuditor,
        setAllocateEDCoder,
        defaultQC,
        setDefaultFacility,
        setDefaultPrimaryHealth,
        setDefaultQC,
        isQc,
        setIsQc,
        priority,
        setPriority,
      }}
    >
      {children}
    </Chartcontext.Provider>
  );
};
export default ChartContextProvider;
